import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import darkModeIcon from 'client/assets/imgs/darkModeIcon.svg';
import darkModeIconInverted from 'client/assets/imgs/darkModeIconInverted.svg';
import MapControl from 'client/pages/MapPage/components/MapControl/MapControl';
import Button from 'client/components/aria/Button/Button';

import styles from './HighContrastButton.module.scss';

const HighContrastButton = ({ highContrast, setHighContrast }) => {
    const intl = useIntl();
    return <MapControl>
        <div className={styles.container}>
            <Button
                className={[highContrast ? styles.active : ''].join(' ')}
                data-testid={'highContrast.button'}
                variant='secondary'
                aria-label={intl.formatMessage({ id: 'highContrast.altText' })}
                onPress={() => setHighContrast(!highContrast)}
                aria-pressed={highContrast}
            >
                <img
                    src={highContrast ? darkModeIconInverted : darkModeIcon}
                    alt={''} width={19} height={19}
                />
            </Button>
        </div>
    </MapControl>;
};

HighContrastButton.propTypes = {
    highContrast: PropTypes.bool.isRequired,
    setHighContrast: PropTypes.func.isRequired
};

export default HighContrastButton;
